var _path, _path2, _rect, _path3, _path4, _circle, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSquareRoundCornersMg = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.1 59H31.8c-1.55 0-2.8-1.25-2.8-2.8V23.8c0-1.55 1.25-2.8 2.8-2.8h32.3a2.875 2.875 0 0 1 2.9 2.8v32.3c0 1.6-1.3 2.9-2.9 2.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 60H31.8c-2.07 0-3.75-1.68-3.75-3.75V23.8c0-2.07 1.68-3.75 3.75-3.75h32.33A3.87 3.87 0 0 1 68 23.77V56.1a3.863 3.863 0 0 1-3.82 3.9h-.08Zm0-38H31.8c-.98.03-1.77.82-1.8 1.8v32.4c0 1 .8 1.82 1.8 1.85h32.3c1.09 0 1.97-.87 2-1.95V23.8a1.935 1.935 0 0 0-2-1.8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.44,
    height: 19.38,
    x: 78.68,
    y: 57.22,
    fill: "#fff",
    rx: 0.95,
    ry: 0.95,
    transform: "rotate(-54.71 80.902 66.909)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.29 74.9c-.4 0-.79-.12-1.11-.35L71.9 64.46c-.86-.61-1.07-1.8-.46-2.66l1.46-2.07c.6-.86 1.79-1.07 2.65-.46l14.29 10.1c.84.61 1.04 1.77.46 2.63l-1.46 2.1c-.36.5-.93.8-1.55.8ZM74.5 60.84l-1.47 2.07L87.32 73l1.47-2L74.5 60.84Zm14.29 10.09.77.55-.77-.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m76.194 65.871 2.576-3.641 1.559 1.103-2.575 3.641z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.99,
    cy: 55.66,
    r: 11.6,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.97 68.21c-6.94 0-12.56-5.62-12.56-12.56s5.62-12.56 12.56-12.56c2.61 0 5.15.81 7.28 2.32 5.66 4 7.01 11.83 3.01 17.49a12.543 12.543 0 0 1-10.28 5.31Zm0-23.2c-5.87.05-10.58 4.84-10.53 10.71.05 5.87 4.84 10.58 10.71 10.53 5.87-.05 10.58-4.84 10.53-10.71-.03-3.45-1.73-6.66-4.56-8.63-1.8-1.26-3.95-1.92-6.15-1.91Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.06 62.83h-3.65l-1.7-4h5.35c4.42 0 8-3.58 8-8v-6.68l4 .85v5.83c0 6.63-5.37 12-12 12Z"
  })));
};
export default SvgSquareRoundCornersMg;